
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendario-avvento",
      function () {
        return require("private-next-pages/calendario-avvento/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calendario-avvento"])
      });
    }
  